import { render } from "./X12.vue?vue&type=template&id=6686930a"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/X12.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6686930a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6686930a', __exports__)) {
    api.reload('6686930a', __exports__)
  }
  
  module.hot.accept("./X12.vue?vue&type=template&id=6686930a", () => {
    api.rerender('6686930a', render)
  })

}


export default __exports__